import { useDebounce } from '@as/cotopaxi';
import { useEffect, useState } from 'react';
import { DELAY } from '../constants/GeneralConstants';
const VIEWPORT_HEIGHT_ADJUSTMENT = 100;
// this only works when meta viewport has default value(resizes-visual) for "interactive-widget" property
export const useVirtualKeyboard = () => {
    const [virtualKeyboardHeight, setVirtualKeyboardHeight] = useState(null);
    const handleVisualViewportResize = useDebounce((event) => {
        const visualViewportHeight = event.target.height;
        const windowHeight = window.innerHeight;
        // visualViewportHeight may initially be slightly smaller than windowHeight
        if (visualViewportHeight + VIEWPORT_HEIGHT_ADJUSTMENT < windowHeight) {
            setVirtualKeyboardHeight(windowHeight - visualViewportHeight);
        }
        else {
            setVirtualKeyboardHeight(null);
        }
    }, DELAY.DELAY_20);
    useEffect(() => {
        window.visualViewport && window.visualViewport.addEventListener('resize', handleVisualViewportResize);
        return () => {
            window.visualViewport && window.visualViewport.removeEventListener('resize', handleVisualViewportResize);
        };
    }, []);
    return virtualKeyboardHeight;
};
